import { useContext } from 'react';
import { Button, Table, Tag } from 'antd';
import {
  FileExcelOutlined,
  FilePdfOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import useAppUsers from './useAppUsers';
import PageHeader from '../../components/PageHeader';
import ActiveFiltersBar from '../../components/ActiveFiltersBar';
import TablePagination from '../../components/TablePagination';
import TableCard from '../../components/TableCard';
import TableDicaHint from '../../components/TableDicaHint';
import { ThemeContext } from '../../contexts/ThemeContext';
import { poeValorComPontosEmMil } from '../../utils/Conversores';

export default function AppUsers() {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === 'dark';

  const {
    isLoading,
    columns,
    tableData,
    navigate,
    totalAppUsers,
    tableParams,
    activeFilterItems,
    handleTableChange,
    handlePaginationChange,
    handleClearAllFilters,
    handleExport,
  } = useAppUsers();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <PageHeader
        icon={<TeamOutlined />}
        title="Usuários do Aplicativo"
        tag={<Tag color="blue">{poeValorComPontosEmMil(totalAppUsers)} cadastrados</Tag>}
        subtitle="Gerencie e visualize todos os cidadãos cadastrados no aplicativo do município"
        actions={
          <>
            <Button
              icon={<FileExcelOutlined style={{ color: '#52c41a' }} />}
              onClick={() => handleExport('excel')}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                fontWeight: 500,
              }}
            >
              Exportar Excel
            </Button>
            <Button
              icon={<FilePdfOutlined style={{ color: '#ff4d4f' }} />}
              onClick={() => handleExport('pdf')}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                fontWeight: 500,
              }}
            >
              Exportar PDF
            </Button>
          </>
        }
      />

      <ActiveFiltersBar
        filters={activeFilterItems}
        onClearAll={handleClearAllFilters}
      />

      <TableDicaHint text="Dê um clique em qualquer linha da tabela para abrir o cadastro detalhado do usuário." />

      <TablePagination
        current={tableParams.pagination.current}
        pageSize={tableParams.pagination.pageSize}
        total={totalAppUsers}
        itemName="usuários"
        onChange={handlePaginationChange}
      />

      <TableCard>
        <Table
          rowKey="id"
          className={`modern-data-table ${isDark ? 'modern-data-table-dark' : ''}`}
          columns={columns}
          dataSource={tableData}
          loading={isLoading}
          pagination={false}
          onChange={handleTableChange}
          onRow={(record) => ({
            onClick: () => {
              navigate(`/usuarios/aplicativo/visualizar/${record.id}`);
            },
            style: {
              cursor: 'pointer',
            },
          })}
        />
      </TableCard>

      <TablePagination
        current={tableParams.pagination.current}
        pageSize={tableParams.pagination.pageSize}
        total={totalAppUsers}
        itemName="usuários"
        onChange={handlePaginationChange}
      />
    </div>
  );
}